konnyScript(function($){
    
  var swiper = new Swiper("#outgif_swiper_slide1", {
    slidesPerView:1,
    slidesPerGroup:1,
    centeredSlides:true,
    loop:true,
    effect:'fade',
    speed:0,
    autoplay:{
      delay:700,
      disableOnInteraction:false,
    },
    scrollbar: {
      el: '#outgif_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#outgif_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#outgif_swiper_slide1 .swiper-button-next',
      prevEl: '#outgif_swiper_slide1 .swiper-button-prev',
    },
  });
  
  
  var swiper = new Swiper("#dec_swiper_slide1", {
    slidesPerView:2.05,
    slidesPerGroup:1,
    spaceBetween:15,
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#dec_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#dec_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#dec_swiper_slide1 .swiper-button-next',
      prevEl: '#dec_swiper_slide1 .swiper-button-prev',
    },
  });
  
  var swiper = new Swiper("#dec_swiper_slide2", {
    slidesPerView:2.05,
    slidesPerGroup:1,
    spaceBetween:15,
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#dec_swiper_slide2 .swiper-scrollbar',
    },
    pagination: {
      el: '#dec_swiper_slide2 .swiper-pagination',
    },
    navigation: {
      nextEl: '#dec_swiper_slide2 .swiper-button-next',
      prevEl: '#dec_swiper_slide2 .swiper-button-prev',
    },
  });

  var swiper = new Swiper("#dec_swiper_slide3", {
    slidesPerView:2.05,
    slidesPerGroup:1,
    spaceBetween:15,
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#dec_swiper_slide3 .swiper-scrollbar',
    },
    pagination: {
      el: '#dec_swiper_slide3 .swiper-pagination',
    },
    navigation: {
      nextEl: '#dec_swiper_slide3 .swiper-button-next',
      prevEl: '#dec_swiper_slide3 .swiper-button-prev',
    },
  });


  var swiper = new Swiper("#dec_swiper_slide4", {
    slidesPerView:2.05,
    slidesPerGroup:1,
    spaceBetween:15,
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#dec_swiper_slide4 .swiper-scrollbar',
    },
    pagination: {
      el: '#dec_swiper_slide4 .swiper-pagination',
    },
    navigation: {
      nextEl: '#dec_swiper_slide4 .swiper-button-next',
      prevEl: '#dec_swiper_slide4 .swiper-button-prev',
    },
  });

  if($('.outerEvent .navWrap').length){
    var eventMain = $('.outerEvent .mainWrap');
    var eventMainHeight = eventMain.outerHeight();
    var eventMainTop = eventMain.offset().top;
    var navFixStart = eventMainTop + eventMainHeight;
    
    if($(window).scrollTop() > navFixStart){
      $('.outerEvent .navWrap').addClass('fix');
    } else{
      $('.outerEvent .navWrap').removeClass('fix');
    }
  
    var activeHeight01 = $('#outNavi01').offset().top;
    var activeHeight02 = $('#shopify-section-template--18400713507054__custom_liquid_7VdgxT').offset().top;
    var activeHeight03 = $('#shopify-section-template--18400713507054__custom_liquid_zA9kBW').offset().top;
    
    activeHeight01 = parseInt(activeHeight01 - 135);
    activeHeight02 = parseInt(activeHeight02 - 135);
    activeHeight03 = parseInt(activeHeight03 - 135);
    
    if($(window).scrollTop() > activeHeight03){
      $('.outerEvent .navWrap li').removeClass('on');
      $('.outerEvent .navWrap li:nth-child(3)').addClass('on');
    } else if($(window).scrollTop() > activeHeight02){
      $('.outerEvent .navWrap li').removeClass('on');
      $('.outerEvent .navWrap li:nth-child(2)').addClass('on');
    } else{
      $('.outerEvent .navWrap li').removeClass('on');
      $('.outerEvent .navWrap li:nth-child(1)').addClass('on');
    }
  }
    
  $(window).scroll(function(){
    if($('.outerEvent .navWrap').length){
      var eventMain = $('.outerEvent .mainWrap');
      var eventMainHeight = eventMain.outerHeight();
      var eventMainTop = eventMain.offset().top;
      var navFixStart = eventMainTop + eventMainHeight;

      if($(window).scrollTop() > navFixStart){
        $('.outerEvent .navWrap').addClass('fix');
      } else{
        $('.outerEvent .navWrap').removeClass('fix');
      }

      var activeHeight01 = $('#outNavi01').offset().top;
      var activeHeight02 = $('#shopify-section-template--18400713507054__custom_liquid_7VdgxT').offset().top;
      var activeHeight03 = $('#shopify-section-template--18400713507054__custom_liquid_zA9kBW').offset().top;

      activeHeight01 = parseInt(activeHeight01 - 135);
      activeHeight02 = parseInt(activeHeight02 - 135);
      activeHeight03 = parseInt(activeHeight03 - 135);

      if($(window).scrollTop() > activeHeight03){
        $('.outerEvent .navWrap li').removeClass('on');
        $('.outerEvent .navWrap li:nth-child(3)').addClass('on');
      } else if($(window).scrollTop() > activeHeight02){
        $('.outerEvent .navWrap li').removeClass('on');
        $('.outerEvent .navWrap li:nth-child(2)').addClass('on');
      } else{
        $('.outerEvent .navWrap li').removeClass('on');
        $('.outerEvent .navWrap li:nth-child(1)').addClass('on');
      }
    }
  })
  
});